import React, { lazy } from 'react';
import { roleSet } from 'src/constants/role';

const ProductsConfiguratorPage = lazy(() => import('./ProductsConfigurator'));
const IngredientsConfiguratorPage = lazy(
  () => import('./IngredientsConfigurator')
);
const PromotionsConfiguratorPage = lazy(
  () => import('./PromotionsConfigurator')
);
const OthersConfiguratorPage = lazy(() => import('./OthersConfigurator'));

export const configuratorTabs = [
  {
    path: 'products',
    element: <ProductsConfiguratorPage />,
    handle: { label: 'Товары', roles: roleSet.adminToSuperAdmin },
  },
  {
    path: 'ingredients',
    element: <IngredientsConfiguratorPage />,
    handle: { label: 'Экстра', roles: roleSet.adminToSuperAdmin },
  },
  {
    path: 'promotions',
    element: <PromotionsConfiguratorPage />,
    handle: { label: 'Акции', roles: roleSet.adminToSuperAdmin },
  },
  {
    path: 'others',
    element: <OthersConfiguratorPage />,
    handle: { label: 'Прочее', roles: roleSet.adminToSuperAdmin },
  },
];
